import { cn } from '@heidi/utils';
import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

interface MobileAppQrCodeProps {
  value: string;
  size: number;
  className?: string;
}

export const MobileAppQrCode = ({ value, size, className }: MobileAppQrCodeProps) => {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toString(value, { type: 'svg', errorCorrectionLevel: 'M', margin: 0 })
      .then((result) => {
        if (!cancelled) setSvg(result);
      })
      .catch(() => {
        if (!cancelled) setSvg(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value]);

  return (
    <div className={cn('inline-flex items-center justify-center', className)}>
      <div
        role="img"
        aria-label="QR code"
        className="[&>svg]:block [&>svg]:size-full"
        style={{ width: size, height: size }}
        {...(svg && { dangerouslySetInnerHTML: { __html: svg } })}
        data-value={value}
      />
    </div>
  );
};
